import { render, staticRenderFns } from "./NavBarTop.vue?vue&type=template&id=90480534&scoped=true&"
import script from "./NavBarTop.vue?vue&type=script&lang=js&"
export * from "./NavBarTop.vue?vue&type=script&lang=js&"
import style0 from "./NavBarTop.vue?vue&type=style&index=0&id=90480534&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90480534",
  null
  
)

export default component.exports